export const getReferrer = () => {
  if (typeof document !== 'undefined') {
    return document.referrer;
  }
};
